module.exports = __webpack_public_path__ + "media/images/menu/pavo-54217a16f51fcc157e18ef555e39de00.jpg";